import { Checked3 } from '@uikit/icons/Checked3';

import NextLink from '@shared/common/components/NextLink';

export interface SuccessSwapTxInfo {
  chainScanLink: string;
}

export interface MagicSwapSuccessViewProps {
  successTxInfo?: SuccessSwapTxInfo;
  createNewSwap: () => void;
}

const MagicSwapSuccessView = ({ successTxInfo, createNewSwap }: MagicSwapSuccessViewProps) => {
  const { chainScanLink } = successTxInfo || {};

  return (
    <div className="flex flex-col w-full items-center justify-center">
      <h3 className="mb-[72px] text-[28px] font-semibold">Transaction completed</h3>

      <Checked3 className="icon-[100px] text-green-800 mb-[24px]" />

      {chainScanLink && (
        <NextLink
          href={chainScanLink}
          target="_blank"
          rel="noreferrer  noopenner"
          className="underline text-primary"
        >
          Watch the swap at block explorer
        </NextLink>
      )}

      <button
        className="w-full button button-lg button-secondary mt-[64px] h-[54px] text-lg gap-3"
        onClick={createNewSwap}
      >
        Create New Swap
      </button>
    </div>
  );
};

export default MagicSwapSuccessView;
